import { useCallback } from 'react';
import { getAssignmentPublishErrors } from 'utils/assignmentSettingsValidation';

const useAssignmentEditorValidation = ({
    form,
    setErrors,
    isGradingFeatureDisabled,
    isFeedbackFeatureDisabled,
    isInlineCommentsFeatureDisabled,
}) =>
    useCallback(() => {
        const errors = getAssignmentPublishErrors(form, {
            isGradingFeatureDisabled,
            isFeedbackFeatureDisabled,
            isInlineCommentsFeatureDisabled,
        });
        setErrors(errors);
        return {
            isValid: !Object.keys(errors).length,
            errors,
        };
    }, [form, isFeedbackFeatureDisabled, isGradingFeatureDisabled, isInlineCommentsFeatureDisabled, setErrors]);

export default useAssignmentEditorValidation;
